import { DialogComponent } from '../../components/core/panels/dialog.component';

/**
 * Represents an action on UI such as menu link, button, toolbar item.
 */
export class Action {
  /**
   * Text to display to user
   */
  label?: string;

  /**
   * Icon name from material icons
   */
  icon?: string;

  /**
   * Unique identifier for this action
   */
  key?: string;

  /**
   * Alternate text value
   */
  alt?: string;

  /**
   * Navigation route
   */
  routerLink?: string | any[];

  /**
   * Parameters for route navigation
   */
  queryParams?: any;

  /**
   * Tooltip text value
   */
  title?: string;

  /**
   * Badge value
   */
  badge?: string | number;

  /**
   * Placeholder for misc. data
   */
  data?: any;

  /**
   * Type of action
   */
  type?: string;

  /**
   * Property name for reflection
   */
  name?: string;

  /**
   * Child actions
   */
  items?: Action[];

  /**
   * Dialog reference useful for modal popup on click
   */
  dialog?: DialogComponent;

  active?: boolean = false;

  authorized?: boolean = false;

  disabled?: boolean = false;

  public constructor(init?: Partial<Action>) {
    Object.assign(this, init);
  }
}
